<template>
    <table class="w-100 mt-3 table-border-thick table" style="border-width: 3px;">
        <tbody>
            <tr>
                <td>
                    <h3>{{ $t('report.bySections') }}</h3>
                    <table class="w-100 table-sm table-borderless" v-for="section in report.sections" :key="section.section_code">
                        <tbody>
                            <tr>
                                <th>{{ $t('report.section') }} {{ section.section_code }}</th>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.sell.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.sell`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.sell.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.buy.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.buy`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.buy.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.sell_return.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.sellReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.sell_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1" style="width:20%;">{{ section.operations.buy_return.count }}</td>
                                <td class="align-top flex-grow-1">{{ $t(`report.buyReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ section.operations.buy_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="w-100 table-sm table-borderless" v-for="tax in report.taxes" :key="tax.id">
                        <tr>
                            <td class="align-top flex-grow-1" style="width:20%;">
                                {{ $t('report.tax') }}
                            </td>
                            <td class="align-top flex-grow-1" >
                                {{ tax.percent }}
                            </td>
                            <td class="flex-shrink-1" align="right">
                                {{ $t(`report.taxType.${tax.tax_type}`) }}
                            </td>
                        </tr>
                        <tr>
                            <td class="align-top flex-grow-1" style="width:20%;"></td>
                            <td class="align-top flex-grow-1">{{ $t('report.taxTurnover') }}</td>
                            <td class="flex-shrink-1" align="right">
                                {{ tax.operations.sell.turnover }}&nbsp;&#8376;
                            </td>
                        </tr>
                        <tr>
                            <td class="align-top flex-grow-1" style="width:20%;"></td>
                            <td class="align-top flex-grow-1">{{ $t('report.tax') }}</td>
                            <td class="flex-shrink-1" align="right">
                                {{ tax.operations.sell.sum }}&nbsp;&#8376;
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <h3>{{ $t('report.reportWithoutDamping') }}</h3>
                    <table class="w-100 table-sm table-borderless">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.startShiftNonNullableSums.sell`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.start_shift_non_nullable_sums.sell.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.startShiftNonNullableSums.buy`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.start_shift_non_nullable_sums.buy.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.startShiftNonNullableSums.sellReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.start_shift_non_nullable_sums.sell_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.startShiftNonNullableSums.buyReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.start_shift_non_nullable_sums.buy_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="w-100 table-sm table-borderless mb-2" style="border-top:1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1" >{{ $t(`report.ticketOperations.sell`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.sell.tickets_total_count }}
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">
                                    {{ report.ticket_operations.sell.tickets_count }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.sell.tickets_sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.cash`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell.payments.cash.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.card`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell.payments.card.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                                <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.credit`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell.payments.credit.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.tare`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell.payments.tare.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="w-100 table-sm table-borderless mb-2" style="border-top:1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1" >{{ $t(`report.ticketOperations.buy`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.buy.tickets_total_count }}
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">
                                    {{ report.ticket_operations.buy.tickets_count }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.buy.tickets_sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.cash`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy.payments.cash.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.card`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy.payments.card.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                                <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.credit`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy.payments.credit.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.tare`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy.payments.tare.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="w-100 table-sm table-borderless mb-2" style="border-top:1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1" >{{ $t(`report.ticketOperations.sellReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.sell_return.tickets_total_count }}
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">
                                    {{ report.ticket_operations.sell_return.tickets_count }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.sell_return.tickets_sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.cash`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell_return.payments.cash.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.card`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell_return.payments.card.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                                <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.credit`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell_return.payments.credit.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.tare`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.sell_return.payments.tare.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="w-100 table-sm table-borderless mb-2" style="border-top:1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1" >{{ $t(`report.ticketOperations.buyReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.buy_return.tickets_total_count }}
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">
                                    {{ report.ticket_operations.buy_return.tickets_count }}
                                </td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.ticket_operations.buy_return.tickets_sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.cash`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy_return.payments.cash.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.card`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy_return.payments.card.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                                <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.credit`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy_return.payments.credit.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1 py-0">
                                    {{ $t(`report.paymentType.tare`) }}
                                </td>
                                <td class="flex-shrink-1 py-0" align="right">
                                    {{ report.ticket_operations.buy_return.payments.tare.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>

            <tr>
                <td>
                    <table class="w-100 table-sm table-borderless">
                        <tbody>
                            <tr>
                                <td>{{ $t(`report.withdrawal`) }}</td>
                                <td align="right">{{ report.money_placements.withdrawal.operations_total_count }}</td>
                            </tr>
                            <tr>
                                <td>{{ report.money_placements.withdrawal.operations_count }}</td>
                                <td align="right">{{ report.money_placements.withdrawal.operations_sum }}&nbsp;&#8376;</td>
                            </tr>
                            <tr style="border-top:1px solid #dee2e6;">
                                <td>{{ $t(`report.deposit`) }}</td>
                                <td align="right">{{ report.money_placements.deposit.operations_total_count }}</td>
                            </tr>
                            <tr>
                                <td>{{ report.money_placements.deposit.operations_count }}</td>
                                <td align="right">{{ report.money_placements.deposit.operations_sum }}&nbsp;&#8376;</td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <table class="w-100 table-sm table-borderless">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.canceledTickets`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    0
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">0</td>
                                <td class="flex-shrink-1" align="right">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <table class="w-100 table-sm table-borderless">
                        <tbody>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.cashSum`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.cash_sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.revenue`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.revenue }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.closeShiftNonNullableSums.sell`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.non_nullable_sums.sell.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.closeShiftNonNullableSums.buy`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.non_nullable_sums.buy.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.closeShiftNonNullableSums.sellReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.non_nullable_sums.sell_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                            <tr>
                                <td class="align-top flex-grow-1">{{ $t(`report.closeShiftNonNullableSums.buyReturn`) }}</td>
                                <td class="flex-shrink-1" align="right">
                                    {{ report.non_nullable_sums.buy_return.sum }}&nbsp;&#8376;
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: 'XReportDetails',
    props: {
        report: Object
    }
}
</script>
